import { Container, Typography } from "@mui/material"

function NotFound() {
  return (
    <Container>
      <Typography variant="h2">Page not found.</Typography>
    </Container>
  )
}

export default NotFound